export const WorkData = [
  {
    company: "Click valley",
    designation: "VueJs Developer",
    dateJoining: "12-08-2021",
    dateEnd: "28-12-2021",
    companyLogo:
      "https://upwork-usw2-prod-assets-static.s3.us-west-2.amazonaws.com/org-logo/425314016441823232",
    work: "Created the interface and also improved the performance by 15% of CV-Project manager Dashboard using Vuejs on the frontend",
  },
  {
    company: "Nss Pvt Ltd",
    designation: "ReactJs Developer",
    dateJoining: "02-01-2022",
    dateEnd: "Present",
    companyLogo:
      "https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/ltqewdfkyr1txq0cyoce",
    work: "Working in Nss pvt ltd as a React js developer in this company i have worked on  helth care website ,auotomobile website ,construction website and career website ",
  },
];
